import React from 'react';
import { useIntl } from 'react-intl';
import { Redirect } from 'react-router-dom';

import { useDefaultLoginRoute } from '../../hooks/use-user-setting';
import { useShowProgressiveDisclosure } from '../../feature-flags/hooks/use-show-progressive-disclosure';
import { SetupContextProvider } from './context';
import { useAppBrandContext } from '../../app-brand/app-brand-context-provider';

import { SetupBody } from './setup-body/setup-body';
import messages from './messages';
import style from './style.module.less';

const SetupPage = () => {
  const intl = useIntl();
  const defaultRoute = useDefaultLoginRoute();
  const shouldShowProgressiveDisclosure = useShowProgressiveDisclosure();
  const { SetupPageLogoSrc } = useAppBrandContext();

  if (!shouldShowProgressiveDisclosure) {
    return <Redirect to={defaultRoute} />;
  }

  return (
    <div className={style['setup-container']}>
      <SetupContextProvider>
        <div className={style['app-logo']}>
          <img alt={intl.formatMessage(messages.shipstationLogo)} src={SetupPageLogoSrc} />
        </div>
        <SetupBody />
      </SetupContextProvider>
    </div>
  );
};

export default SetupPage;
